import { imagesApi as api } from './base-api';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getV1QrCodesBySlugAndNameExt: build.query<
      GetV1QrCodesBySlugAndNameExtApiResponse,
      GetV1QrCodesBySlugAndNameExtApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/qr/codes/${queryArg.slug}/${queryArg.name}.${queryArg.ext}`,
        params: {
          errorCorrectionLevel: queryArg.errorCorrectionLevel,
          width: queryArg.width,
        },
      }),
    }),
    getV1Health: build.query<GetV1HealthApiResponse, GetV1HealthApiArg>({
      query: () => ({ url: `/v1/health` }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as api };
export type GetV1QrCodesBySlugAndNameExtApiResponse =
  /** status 200 Return code image. */ Blob;
export type GetV1QrCodesBySlugAndNameExtApiArg = {
  /** 6 digit slug, unique for each code. */
  slug: string;
  /** The name of the code. */
  name: string;
  /** The extension of the image file. */
  ext: 'png' | 'svg';
  /** The error correction level of the content. Error correction capability allows to successfully scan a QR Code even if the symbol is dirty or damaged. */
  errorCorrectionLevel?: 'L' | 'M' | 'Q' | 'H';
  /** Forces a specific width for the output image.. */
  width?: number;
};
export type GetV1HealthApiResponse = unknown;
export type GetV1HealthApiArg = void;
export type OpenApiValidatorError = {
  /** Error location in OpenAPI specifications. */
  path: string;
  /** Error message for the specific validation. */
  message: string;
  /** OpenAPI validator errorCode which defines the rule this error is based upon. */
  errorCode: string;
};
export type OpenApiValidatorCompleteError = {
  /** Status code of error response */
  status: string;
  /** Overarching error message for validation. */
  message: string;
  errors: OpenApiValidatorError[];
};
export type StatusError = {
  /** Handled error message, likely usage error. */
  message: string;
};
export type InternalServerError = {
  /** Internal server error. */
  error: string;
};
export const { useGetV1QrCodesBySlugAndNameExtQuery, useGetV1HealthQuery } =
  injectedRtkApi;
